<template>
    <section class="lg:py-[150px] py-[80px] text-white" :style="{ background: backgroundColor }">
        <img v-if="backgroundImage" class="z-0 absolute left-0 hidden lg:block w-full" :src="$asset(backgroundImage, 'public')" alt="" />
        <div class="container mx-auto px-4" :class="{ 'relative z-10': backgroundImage }">
            <div class="grid md:grid-cols-2 gap-12 items-center mx-auto" :class="contentMaxWidth">
                <div :class="imagePosition === 'right' ? 'order-2 lg:order-2' : 'order-1 lg:order-1'">
                    <div class="w-full">
                        <img :alt="imageAlt" :class="imageClass || 'h-full lg:w-auto'" :src="$asset(image, 'public')" />
                    </div>
                </div>
                <div :class="imagePosition === 'right' ? 'order-1 lg:order-1' : 'order-2 lg:order-2'">
                    <h2 class="mb-6" :class="[titleClass, titleColor]">
                        <span v-html="renderTitle()"></span>
                    </h2>
                    <p v-for="(paragraph, index) in paragraphs" :key="`p-${index}`" :class="[paragraphClass, textColor]">
                        {{ paragraph }}
                    </p>
                    <ul v-if="bulletList && bulletList.length" class="space-y-0 mb-6">
                        <li v-for="(item, index) in bulletList" :key="`b-${index}`" class="flex items-start gap-2">
                            <span class="mt-1" :class="bulletColor">•</span>
                            <span :class="[textColor, bulletTextClass]">{{ item }}</span>
                        </li>
                    </ul>
                    <p v-for="(paragraph, index) in afterBulletParagraphs" :key="`ap-${index}`" :class="[textColor, paragraphClass, index > 0 ? 'mb-4' : '']">
                        {{ paragraph }}
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    backgroundColor: {
        type: String,
        default: 'linear-gradient(to bottom right, #072551, #020E20)'
    },
    title: {
        type: String,
        default: ''
    },
    titleHighlight: {
        type: String,
        default: ''
    },
    titleHighlightGradientFrom: {
        type: String,
        default: '#11D2D4'
    },
    titleHighlightGradientTo: {
        type: String,
        default: '#0C7475'
    },
    titleColor: {
        type: String,
        default: 'text-white'
    },
    paragraphs: {
        type: Array,
        default: () => []
    },
    bulletList: {
        type: Array,
        default: () => []
    },
    bulletColor: {
        type: String,
        default: 'text-blue-light'
    },
    textColor: {
        type: String,
        default: 'text-white'
    },
    image: {
        type: String,
        default: ''
    },
    imageAlt: {
        type: String,
        default: ''
    },
    imagePosition: {
        type: String,
        default: 'left',
        validator: (value) => ['left', 'right'].includes(value)
    },
    imageClass: {
        type: String,
        default: ''
    },
    backgroundImage: {
        type: String,
        default: ''
    },
    afterBulletParagraphs: {
        type: Array,
        default: () => []
    },
    titleClass: {
        type: String,
        default: 'text-3xl md:text-4xl font-bold'
    },
    paragraphClass: {
        type: String,
        default: 'text-lg mb-4'
    },
    bulletTextClass: {
        type: String,
        default: ''
    },
    contentMaxWidth: {
        type: String,
        default: 'max-w-6xl'
    }
});

const renderTitle = () => {
    if (!props.titleHighlight) return props.title;

    const highlightRegex = new RegExp(`(${props.titleHighlight})`, 'g');

    return props.title.replace(
        highlightRegex,
        `<span class="bg-gradient-to-r text-transparent bg-clip-text" style="background: linear-gradient(to right, ${props.titleHighlightGradientFrom}, ${props.titleHighlightGradientTo}); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">$1</span>`
    );
};
</script>
